export function containsMultiXPath(multidimensionalArray: string[][], targetArray: string[]) {
  const targetArrayString = JSON.stringify(targetArray) // Convert the target array to a string

  return multidimensionalArray.some((subArray) => {
    return JSON.stringify(subArray) === targetArrayString // Compare stringified versions of sub-arrays
  })
}
